import { fetchLangReducer } from "./fetchLangReducer";
import {combineReducers} from 'redux'

const reducers = combineReducers({
    LanguageData: fetchLangReducer
})

export default reducers